<template>
    <div class="pt-2 mt-4 text-center text-lg-start tags-categories" v-if="tags.length">
        <span class="h2">{{ $t('pages.blog.categories') }}</span>
        <div>
            <button
                v-for="(tag, index) in orderedTags"
                :key="tag.code"
                :class="[
                    'btn',
                    tagInSelectedTags(tag.code) ? 'btn-primary' : 'btn-secondary',
                    !showAllTags && index >= tagsLimit ? 'extra' : '',
                    'btn-sm',
                    'mt-2',
                    'me-1',
                    'tag'
                ]"
                :data-code="tag.code"
                @click="toggleTag(tag.code)"
            >
                {{ tag.name }}
            </button>
        </div>
        <button
            id="readMoreTags"
            class="btn btn-primary btn-sm mt-4"
            v-if="tags.length > tagsLimit"
            @click="toggleShowAllTags"
        >
            {{ showAllTags ? $t('miscellaneous.show_less') : $t('miscellaneous.show_all') }}
        </button>
    </div>
</template>

<script setup>
import { useMobileDetector } from '~/composables/useMobileDetector';

const props = defineProps({
    tags: {
        type: Array,
        required: true
    }
});

const route = useRoute();
const router = useRouter();

const isMobile = useMobileDetector();
const tagsLimit = ref(isMobile ? 10 : 25);
const showAllTags = ref(false);

function tagInSelectedTags(code) {
    const selectedTags = route.query.tags ? route.query.tags.split(',') : [];
    return selectedTags.includes(code);
}

function toggleTag(code) {
    const selectedTags = route.query.tags ? route.query.tags.split(',') : [];
    const tagIndex = selectedTags.indexOf(code);

    if (tagIndex === -1) {
        selectedTags.push(code);
    } else {
        selectedTags.splice(tagIndex, 1);
    }

    const query = { ...route.query, tags: selectedTags.join(',') };
    if (!selectedTags.length) {
        delete query.tags;
    }

    const locale = useNuxtApp().$i18n.locale.value;

    router.push({
        path: `/${locale}/blog/`,
        query,
    });
}

const orderedTags = computed(() => {
    const selectedTags = route.query.tags ? route.query.tags.split(',') : [];
    return [...props.tags].sort((a, b) => {
        const aSelected = selectedTags.includes(a.code);
        const bSelected = selectedTags.includes(b.code);
        return bSelected - aSelected;
    });
});

function toggleShowAllTags() {
    if (showAllTags.value) {
        const container = document.querySelector('.tags-categories');
        if (container) {
            container.scrollIntoView({ behavior: 'smooth' });
        }
    }
    showAllTags.value = !showAllTags.value;
}
</script>
